import { IterableElement } from 'type-fest'

import { FIAT_BALANCE_TICKERS } from './fiat-balance'
import { CRYPTO_TICKERS } from './crypto'

export const EXCHANGE_TICKERS = [...CRYPTO_TICKERS, ...FIAT_BALANCE_TICKERS]

export type ExchangeTicker = IterableElement<typeof EXCHANGE_TICKERS>
